import "./Footer.scss";
import React from "react";
import {
    FaLocationArrow,
    FaMobileAlt,
    FaEnvelope
} from "react-icons/fa";
import Payment from "../../assets/payments.png"
const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="col">
                    <div className="title">
                        About
                    </div>
                    <div className="text">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque 
                        perferendis excepturi est? Ipsum quia numquam
                         praesentium error, facere minus cum temporibus explicabo sint,
                          tenetur facilis consectetur porro.
                    </div>
                </div>
                <div className="col">
                    <div className="title">
                        Contact
                    </div>
                    <div className="c-item">
                        <FaLocationArrow />
                        <div className="text">
                            Lorem ipsum dolor sit
                         amet consectetur adipisicing elit. Molestias, animi.
                        </div>
                    </div>
                    <div className="c-item">
                        <FaMobileAlt />
                        <div className="text">
                            phone: 1234567890
                        </div>
                    </div>
                    <div className="c-item">
                        <FaEnvelope />
                        <div className="text">
                           Email: Email@gmail.com
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="title">
                        Categories
                    </div>
                    <span className="text">Headphones</span>
                    <span className="text">Smart Watches</span>
                    <span className="text">Bluetooth Speakers</span>
                    <span className="text">Wireless airbuds</span>
                    <span className="text">Home Theater</span>
                    <span className="text">Projectors</span>
                </div>
                <div className="col">
                    <div className="title">
                        Pages
                    </div>
                    <span className="text">Home</span>
                    <span className="text"> About</span>
                    <span className="text"> Privacy Policy</span>
                    <span className="text"> Returns</span>
                    <span className="text"> Terms & Conditions</span>
                    <span className="text">Contact Us</span>
                </div>
            </div>
            <div className="bottom-bar">
                <div className="bottom-bar-content">
                    MYRASTORE 2024 CREATED BY .... PREMIUM 
                    ECOMMERCE SOLUTIONS.
                    <img src={Payment} alt="" />
                </div>
                
            </div>
        </footer>
    );
};

export default Footer;
